import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { CollectionFragmentExtended } from '../hasura-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type CollectionByContractSlugVariables = Types.Exact<{
  contractSlug: Types.Scalars['citext'];
  indexedStates: Array<Types.Scalars['Boolean']> | Types.Scalars['Boolean'];
}>;


export type CollectionByContractSlug = { items: Array<(
    Pick<Types.Collection, 'chainId' | 'collectionImageUrl' | 'contractAddress' | 'slug' | 'coverImageUrl' | 'createdAt' | 'creatorAddress' | 'description' | 'id' | 'name' | 'symbol' | 'updatedAt' | 'contractType' | 'moderationStatus' | 'moderationFrom' | 'hiddenAt' | 'deletedAt' | 'baseURI' | 'maxTokenId' | 'isRevealed' | 'brandColor'>
    & { creator: Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>, splits: Array<(
      Pick<Types.Split_Recipient, 'id' | 'contractAddress' | 'indexOfShare' | 'publicKey' | 'sharePercent'>
      & { user: Pick<Types.User, 'name' | 'profileImageUrl' | 'publicKey' | 'username'> }
    )> }
  )> };



export const CollectionByContractSlugDocument = /*#__PURE__*/ `
    query CollectionByContractSlug($contractSlug: citext!, $indexedStates: [Boolean!]!) {
  items: collection(
    where: {slug: {_eq: $contractSlug}, isIndexed: {_in: $indexedStates}}
  ) {
    ...CollectionFragmentExtended
  }
}
    ${CollectionFragmentExtended}`;

export const useCollectionByContractSlug = <
      TData = CollectionByContractSlug,
      TError = ClientError
    >(
      variables: CollectionByContractSlugVariables,
      options?: Omit<UseQueryOptions<CollectionByContractSlug, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionByContractSlug, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionByContractSlug, TError, TData>(
      {
    queryKey: ['CollectionByContractSlug', variables],
    queryFn: hasuraFetcher<CollectionByContractSlug, CollectionByContractSlugVariables>(CollectionByContractSlugDocument, variables),
    ...options
  }
    )};

useCollectionByContractSlug.getKey = (variables: CollectionByContractSlugVariables) => ['CollectionByContractSlug', variables];

export const useInfiniteCollectionByContractSlug = <
      TData = InfiniteData<CollectionByContractSlug>,
      TError = ClientError
    >(
      variables: CollectionByContractSlugVariables,
      options: Omit<UseInfiniteQueryOptions<CollectionByContractSlug, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CollectionByContractSlug, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CollectionByContractSlug, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CollectionByContractSlug.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<CollectionByContractSlug, CollectionByContractSlugVariables>(CollectionByContractSlugDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCollectionByContractSlug.getKey = (variables: CollectionByContractSlugVariables) => ['CollectionByContractSlug.infinite', variables];


useCollectionByContractSlug.fetcher = (variables: CollectionByContractSlugVariables, options?: RequestInit['headers']) => hasuraFetcher<CollectionByContractSlug, CollectionByContractSlugVariables>(CollectionByContractSlugDocument, variables, options);
